import src from "IMAGE";
export default { src, width: 321, height: 169, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQUlEQVR42oWKUQoAERgG5w21294C4QgbRdz/SPjzbmr6Hr6BK8Z8OJdJaSy7bIwda3+UekDrV4IQ6rHhfZFgfzcm5l0HZD5pv1EAAAAASUVORK5CYII="};
